var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("input", {
      ref: "fileInput",
      staticStyle: { display: "none" },
      attrs: { type: "file", accept: "image/*" },
      on: { change: _vm.handleFileUpload },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }